import {doc} from './docs.js';
import {NFT, START, STOP, TICK} from "messaging/message-types.js";
import PadWrapper from '../custom/PadWrapper.js';

doc(
    "pad",
    {
    },
    "Drum pad for sounds",
    (x) => 0,
    {
        inlets: 0
    }
);

export const pad = (object) => {
    let _pad = new PadWrapper(object);
    _pad.zObject = object;
    object.effect = _pad;
    object.width = 201;
    object.height = 227;
    object.needsStart = true;
    object.needsLoad = true;

    return ([msg]) => {
        if (object.effect.pad) {
            object.effect.pad.onSizeChange(object.width, object.height);
            object.effect.pad.sendTags();
        }
    };
};
 
